import { developmentPlanConstants } from '../../_constants';
import { developmentPlanService } from '../../_services';

export const developmentPlanActions = {
    getDevelopmentPlan
};

function getDevelopmentPlan() {
    return dispatch => {
        dispatch(request());
        developmentPlanService.getdevelopmentPlan()
            .then(
                developmentPlan => {
                    dispatch(success(developmentPlan));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: developmentPlanConstants.REQUEST_DEVELOPMENT_PLAN} }
    function success(developmentPlan) { return { type: developmentPlanConstants.RECEIVE_DEVELOPMENT_PLAN, developmentPlan } }
    function failure(error) { return { type: developmentPlanConstants.DEVELOPMENT_PLAN_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/DevelopmentPlan/getDevelopmentPlan.action.js